export default {
  priv: 'manage',
  overviewTitle: 'InspectionEventTypes',
  detailTitle: 'InspectionEventType',
  deleteTitle: 'dit InspectionEventType',
  url: '/manage/inspectioneventtypes',
  apiUrl: '/inspectioneventtypes/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'manage/inspectioneventtypes',
  quickFilter: {
    text: 'Zoek op name',
    value: 'name',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(context, item) {
  //   return false;
  // },
  // customDeletable(context, item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Name', value: 'name', link: '/manage/inspectioneventtypes/{id}', width: '10%'}
  ]
};
